import {
    DOB_SET_VALUE,
    EMPLOYMENT_DATE_SET_VALUE,
    FIRST_NAME_SET_VALUE,
    ID_PASSPORT_SET_VALUE,
    KRA_PIN_NUMBER_SET_VALUE,
    MOBILE_NUMBER_SET_VALUE,
    setDoBValid,
    setEmployementDateValid,
    setFirstNameValid,
    setIdPassortNumberValid,
    setKraPinNumberValid,
    setMobileNumberValid,
    setSurnameValid,
    SURNAME_SET_VALUE,
} from '../../../actions/biasharaFlexi/employeeDetails';
import { getDoBValue } from '../../../selectors/biasharaFlexi/employeeDetails';
import { validationIsEqual } from '../status';
import {
    validateName,
    validateContactNumber,
    validateKraPinNumber,
    validateDateOfBirth,
    validateDate,
    validatePassportNumber,
    validateSurname,
    validateNumericString,
} from '@om/validation';

export function isEmploymentEligible(dob, employmentDate) {
    const minAge = 18;
    const dobDate = new Date(dob);
    const empDate = new Date(employmentDate);
    const today = new Date();

    // Calculate minimum employment date (18 years after DOB)
    const minEmploymentDate = new Date(dobDate);
    minEmploymentDate.setFullYear(minEmploymentDate.getFullYear() + minAge);

    // Validate employment date
    if (empDate < minEmploymentDate) {
        return "Employee must be at least 18 years old at the time of employment.";
    }
    if (empDate > today) {
        return "Employment date cannot be in the future.";
    }

    return null;
}

let prevValidationAction = null;
export const employeeDetailsValidation = (store, next, action) => {
    const employeeDob = getDoBValue(store.getState())
    const validationAction = (() => {
        let error;
        switch (action.type) {
            case FIRST_NAME_SET_VALUE:
                error = validateName(action.value, {
                    subject: 'First Name',
                    required: true,
                });
                return setFirstNameValid(error);

            case KRA_PIN_NUMBER_SET_VALUE:
                error = validateKraPinNumber(action.value, { subject: 'KRA Pin Number', required: true });
                return setKraPinNumberValid(error);

            case MOBILE_NUMBER_SET_VALUE:
                error = validateContactNumber(action.value, {
                    subject: 'Mobile Number',
                    required: true,
                    countryCode: 'ke',
                });
                return setMobileNumberValid(error);

            case SURNAME_SET_VALUE:
                error = validateSurname(action.value, {
                    subject: 'Surname',
                    required: true,
                });
                return setSurnameValid(error);

            case DOB_SET_VALUE:
                error = validateDateOfBirth(action.value, {
                    subject: 'Date of birth',
                    required: true,
                    max: 65,
                    min: 18
                });
                return setDoBValid(error);

            case EMPLOYMENT_DATE_SET_VALUE:
                error = isEmploymentEligible(employeeDob.value, action.value);
                return setEmployementDateValid(error);

            case ID_PASSPORT_SET_VALUE:
                const error1 = validateNumericString(action.value, { min: 8, max: 15, subject: "ID number", required: true });
                const error2 = validatePassportNumber(action.value, { subject: 'Passport number', required: true, });
                error = (!error1 && !error2) ? null : (!error2 ? null : error1);
                return setIdPassortNumberValid(error);

            default:
                return null;
        }
    })();

    if (!validationAction || validationIsEqual(validationAction, prevValidationAction)) {
        return next(action);
    }

    store.dispatch(validationAction);
    prevValidationAction = validationAction;
    return next(action);
};
